'use strict'
/** 此文件的接口已经弃用 */
import axios from 'axios'

const sapConcur = {
  create (formData, token) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_API_URL}b2b-sap-concur-app/linkAccount`,
      headers: { 'Content-Type': 'multipart/form-data', Authorization: token },
      data: formData
    })
  },
  login (email, password) {
    return axios({
      method: 'POST',
      url: `${process.env.VUE_APP_API_URL}b2b-iam-app/authentication/login`,
      data: {
        email,
        password
      }
    })
  }
}

export default sapConcur
